import { IFeature } from 'mod/featureV2/interface';
import { waterFall as pcWaterFall } from '../pc/waterFall';

export const waterFall: IFeature = {
    ...pcWaterFall,
    config: {
        height: 460,
        column: 2,
        spaceBetweenColumns: 24,
        viewMoreText: 'View More 6 >',
        pageSize: 4,
    },
};